import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { IonInput } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import IMask from 'imask';

@Directive({
  selector: '[ao-mask]',
  providers: [IonInput],
})
export class AOMaskDirective implements OnInit, OnDestroy {

  private _masks: any = {
    zipCode: {
      mask: '00.000-000'
    },
    cnpj: {
      mask: '00.000.000/0000-00'
    },
    cpf: {
      mask: '000.000.000-00'
    },
    cpfCnpj: {
      mask: [
        {mask: '000.000.000-00'},
        {mask: '00.000.000/0000-00'}
      ]
    },
    phone: {
      mask: [
        {mask: '(00) 0000-0000'},
        {mask: '(00) 0-0000-0000'}
      ]
    },
    date: {
      mask: Date,
      pattern: 'DD/MM/YYYY',
      blocks: {
        DD: {mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2},
        MM: {mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2},
        YYYY: {mask: IMask.MaskedRange, from: 1900, to: 9999, maxLength: 4}
      },
      format: function (date) {
        let day = date.getDate().toString().padStart(2, 0);
        let month = (date.getMonth() + 1).toString().padStart(2, 0);
        let year = date.getFullYear();
        return [day, month, year].join('/');
      },
      parse: function (str) {
        const parts = str.split('/');
        return new Date(parts[2], parts[1] - 1, parts[0]);
      },
    },
    decimal: {
      mask: Number,
      thousandsSeparator: '.',
      scale: 2,
      signed: false,
      padFractionalZeros: false,
      normalizeZeros: true,
      radix: ',',
      mapToRadix: ['.'],
    },
    int: {
      mask: Number,
      thousandsSeparator: '.',
      scale: 0,
      signed: false,
    }
  };

  @Input('ao-mask') private mask: any;

  @Input('ao-min') private min;

  @Input('ao-max') private max;

  private _destroyed = new Subject<void>();

  constructor(
    public ionInput: IonInput
  ) {
  }

  public async ngOnInit() {
    const element = await this.ionInput.getInputElement();

    const formatter = IMask(element, this.options());

    // formatter.value
    // formatter.unmaskedValue
    // formatter.typedValue = '+55 (61) 1234-5678'

    this.ionInput.value = element.value;
    formatter.updateValue();

    let count = 0;

    this.ionInput.ionChange
      .pipe(takeUntil(this._destroyed))
      .subscribe((event: CustomEvent) => {

        // event.detail.value
        this.ionInput.value = element.value;

        if (count == 0) {
          formatter.updateValue();
          count++;
        }

      });
  }

  public ngOnDestroy() {
    this._destroyed.next();
  }

  private options() {
    if (typeof this.mask == 'string') {
      let options: any = {mask: this.mask};

      if (this._masks[this.mask]) {
        options = this._masks[this.mask];
      }

      if (this.min !== undefined) {
        options.min = this.min;
      }

      if (this.max !== undefined) {
        options.max = this.max;
      }

      if (this.min < 0 || this.max < 0) {
        options.signed = true;
      }

      return options;
    }

    return this.mask;
  }

}